import { logoutApi } from "@/api/services/admin/auth";
import { logout } from "@/utils/api";
import { redirectToLogin } from "@/utils/center";
import { useEffect } from "react";

const Logout = () => {
  useEffect(() => {
    const handleLogout = async () => {
      await logoutApi();
      logout();
      redirectToLogin();
    };

    handleLogout();
  }, []);

  return null;
};

export default Logout;
